import request from '../../axios/axiosconfig.js'
/**
 * 查询设备业务数据
 * @param  params 
 * @returns 
 */
export function deviceBusinessData(params) {
  return request({
    url: '/ps/businessData/deviceBusinessData',
    method: 'get',
    params: params,
    timeout: 300000
  })
}

/**
 * excel下载
 * @param  params 
 * @returns 
 */
export function exportDeviceBusinessData(params){
  return request({
    url: '/ps/businessData/exportDeviceBusinessData',
    method: 'post',
    data: params,
    timeout: 3600000
  })
}

/**
 * 查询订单业务数据
 * @param {params}  
 * @returns 
 */
export function orderBusinessData(params){
  return request({
    url: '/ps/businessData/orderBusinessData',
    method: 'get',
    params: params,
    timeout: 3600000
  })
}

/**
 * excel下载
 * @param  params 
 * @returns 
 */
 export function exportOrderBusinessData(params){
  return request({
    url: '/ps/businessData/exportOrderBusinessData',
    method: 'post',
    data: params,
    timeout: 3600000
  })
}

/**
 * 查询门店业务数据
 * @param {params}  
 * @returns 
 */
 export function storeBusinessData(params){
  return request({
    url: '/ps/businessData/storeBusinessData',
    method: 'get',
    params: params,
    timeout: 300000
  })
}

/**
 * excel下载
 * @param  params 
 * @returns 
 */
 export function exportStoreBusinessData(params){
  return request({
    url: '/ps/businessData/exportStoreBusinessData',
    method: 'post',
    data: params,
    timeout: 3600000
  })
}



// WEBPACK FOOTER //
// ./src/api/businessdata/businessData.js